import { RoleEnum } from '@sr-sdks/api-sdk-axios';
import { DropdownMenuItem } from '@sr/ui-library';
import { DropdownMenu } from '@sr/ui-library';
import { DropdownMenuContent, DropdownMenuTrigger, Icon } from '@sr/ui-library';
import { twMerge } from 'tailwind-merge';
import { AccessLevelMap } from '../constant/Common';

interface IStaffAccessLevelDropdownProps {
  isReadOnly?: boolean;
  onRoleSelect?: (roleKey: RoleEnum) => void;
  selectedRoleKey?: RoleEnum;
}

const StaffAccessLevelDropdown = ({
  isReadOnly = false,
  onRoleSelect,
  selectedRoleKey = RoleEnum.CustomerSupportUser,
}: IStaffAccessLevelDropdownProps) => {
  if (isReadOnly) {
    return <>{AccessLevelMap[selectedRoleKey]}</>;
  }

  const accessLevelItems = [
    RoleEnum.SystemAdmin,
    RoleEnum.CustomerSupportUser,
    RoleEnum.CustomerSupportSupervisor,
    RoleEnum.PaymentAuthoriser,
    RoleEnum.PaymentPreparer,
  ];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <div className="flex items-center gap-2">
          {AccessLevelMap[selectedRoleKey]}
          {!isReadOnly && (
            <Icon data-testid="icon-chevronDown" icon="chevronDown" />
          )}
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {accessLevelItems.map(
          (accessLevel) =>
            accessLevel && (
              <DropdownMenuItem
                key={accessLevel}
                className={twMerge(
                  'w-72 px-4 py-2 md:w-96',
                  selectedRoleKey === accessLevel
                    ? 'pointer-events-none !font-bold !opacity-100'
                    : '',
                )}
                onClick={() => onRoleSelect?.(accessLevel)}
              >
                <div className="grid-flow-row">
                  <p>{AccessLevelMap[accessLevel]}</p>
                </div>
              </DropdownMenuItem>
            ),
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default StaffAccessLevelDropdown;
